module.exports = __webpack_public_path__ + "static/media/lightMode.b4520760.svg";